export { default as AdminMenuConfig } from './AdminMenuConfig';
